<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
</template>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  // 字体抗锯齿渲染
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: zhuan;
  src: url(/font/fangZhengXiaoZhuan.ttf);
}

::selection {
  color: #fff;
  background-color: #54c41c !important;
}

::-moz-selection {
  color: #fff;
  background-color: #54c41c !important;
}

::-webkit-selection {
  color: #fff;
  background-color: #54c41c !important;
}

* {
  margin: 0;
  padding: 0;
}

body {
  letter-spacing: 1px;
  font-size: 16px !important;
  font-family: "Varela Round", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol";
}
body p {
  margin-bottom: 0;
}
body a {
  text-decoration: none;
  color: #2d8cf0;
}
body ul {
  padding-left: 0;
  margin-bottom: 0;
}
body li {
  list-style: none;
}

/* 浏览器滚动条 */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-corner,
::-webkit-scrollbar-track {
  background-color: #e2e2e2;
}

::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-button:vertical {
  display: none;
}

::-webkit-scrollbar-thumb:vertical:hover {
  background-color: rgba(0, 0, 0, 0.35);
}

::-webkit-scrollbar-thumb:vertical:active {
  background-color: rgba(0, 0, 0, 0.38);
}
</style>
